module.exports = __webpack_public_path__ + "img/27.a19cd4ba.png";